/* tslint:disable */

declare var Object: any;
export interface TsaimasterInterface {
  "aiName": string;
  "aiType"?: string;
  "dataType"?: number;
  "accessCode"?: string;
  "description"?: string;
  "freqDefault"?: string;
  "freqValue"?: string;
  "freqDesc"?: string;
  "timeUnit"?: string;
  "additionalFilter"?: string;
  "userType"?: string;
  "aiCode"?: number;
  "additionalFilterDefault": string;
}

export class Tsaimaster implements TsaimasterInterface {
  "aiName": string;
  "aiType": string;
  "dataType": number;
  "accessCode": string;
  "description": string;
  "freqDefault": string;
  "freqValue": string;
  "freqDesc": string;
  "timeUnit": string;
  "additionalFilter": string;
  "userType": string;
  "aiCode": number;
  "additionalFilterDefault": string;
  constructor(data?: TsaimasterInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tsaimaster`.
   */
  public static getModelName() {
    return "Tsaimaster";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tsaimaster for dynamic purposes.
  **/
  public static factory(data: TsaimasterInterface): Tsaimaster{
    return new Tsaimaster(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tsaimaster',
      plural: 'Tsaimasters',
      path: 'Tsaimasters',
      properties: {
        "aiName": {
          name: 'aiName',
          type: 'string'
        },
        "aiType": {
          name: 'aiType',
          type: 'string'
        },
        "dataType": {
          name: 'dataType',
          type: 'number'
        },
        "accessCode": {
          name: 'accessCode',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "freqDefault": {
          name: 'freqDefault',
          type: 'string'
        },
        "freqValue": {
          name: 'freqValue',
          type: 'string'
        },
        "freqDesc": {
          name: 'freqDesc',
          type: 'string'
        },
        "timeUnit": {
          name: 'timeUnit',
          type: 'string'
        },
        "additionalFilter": {
          name: 'additionalFilter',
          type: 'string'
        },
        "userType": {
          name: 'userType',
          type: 'string'
        },
        "aiCode": {
          name: 'aiCode',
          type: 'number'
        },
        "additionalFilterDefault": {
          name: 'additionalFilterDefault',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tsaimaster.ts